var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.74609 20.9933C6.50867 20.9933 8.74818 23.2328 8.74818 25.9954C8.74818 23.2328 10.9877 20.9933 13.7503 20.9933C10.9877 20.9933 8.74818 18.7538 8.74818 15.9912C8.74818 18.7538 6.50867 20.9933 3.74609 20.9933Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.251 17.2413C19.0136 17.2413 21.2531 19.4808 21.2531 22.2434C21.2531 19.4808 23.4926 17.2413 26.2551 17.2413C23.4926 17.2413 21.2531 15.0018 21.2531 12.2393C21.2531 15.0018 19.0136 17.2413 16.251 17.2413V17.2413Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74805 8.48743C11.5106 8.48743 13.7501 10.7269 13.7501 13.4895C13.7501 10.7269 15.9896 8.48743 18.7522 8.48743C15.9896 8.48743 13.7501 6.24793 13.7501 3.48535C13.7501 6.24793 11.5106 8.48743 8.74805 8.48743Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsIcon);
export default __webpack_public_path__ + "static/media/stars-icon.d931a4d0d8f1b4040e957d840a6df89b.svg";
export { ForwardRef as ReactComponent };